import { createContext, useContext } from 'react';
import { IRequestMaterialStageContext } from '@entities/requestMaterial/model/types';

export const RequestMaterialStageContext = createContext<IRequestMaterialStageContext | null>(null);
export const useRequestMaterialStageContext = () => {
    const ctx = useContext(RequestMaterialStageContext);
    if (!ctx) throw new Error('Missing RequestMaterialStageContext');
    return ctx;
};
